import React from "react";
import Proptypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";

const Star = ({ fill }) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
            d="M7.5 0L10.05 4.6L15 5.73L11.63 9.7L12.14 15L7.5 12.85L2.86 15L3.38 9.7L0 5.73L4.95 4.6L7.5 0Z"
            fill={fill}
        />
    </svg>
);

const HalfStar = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
            d="M2.86 15L7.5 12.85V0L4.95 4.6L0 5.73L3.38 9.7L2.86 15Z"
            fill="#F68921"
        />
        <path
            d="M7.5 0L10.05 4.6L15 5.73L11.63 9.7L12.14 15L7.5 12.85V0Z"
            fill="#C8C8C8"
        />
    </svg>
);

const StarRating = ({ rating }) => {
    const stars = [];
    for (let i = 0; i < NUMBER.FIVE; i++) {
        const diff = rating - i;
        if (diff >= 1) {
            stars.push(<Star key={i} fill="#F68921" />);
        } else if (diff >= NUMBER.DECIMAL_FIVE) {
            stars.push(<HalfStar key={i} />);
        } else {
            stars.push(<Star key={i} fill="#C8C8C8" />);
        }
    }

    return <div style={{ display: "flex", gap: "4px" }}>{stars}</div>;
};

StarRating.propTypes = {
    rating: Proptypes.string
};
Star.propTypes = {
    fill: "#C8C8C8"
};
export default StarRating;
